var React = require('react');

function SidebarIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.7381 2.16216H2.2619V13.8378H16.7381V2.16216ZM2.2619 0C1.01269 0 0 0.968033 0 2.16216L0 13.8378C0 15.032 1.01269 16 2.26191 16H16.7381C17.9873 16 19 15.032 19 13.8378V2.16216C19 0.968033 17.9873 0 16.7381 0L2.2619 0Z","fill":"#A5A9AF","key":0}),React.createElement("path",{"id":"bar","d":"M2 2.13333H8V13.8667H2V2.13333Z","fill":"#A5A9AF","fillOpacity":"0.4","key":1})]);
}

SidebarIconInline.defaultProps = {"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none"};

module.exports = SidebarIconInline;

SidebarIconInline.default = SidebarIconInline;
